const state = {
  port: null,
  wsUrl: null,
}

export const setPort = port => {
  state.port = port
}

export const getPort = () => state.port

export const setWsUrl = wsUrl => {
  state.wsUrl = wsUrl
}

export const getWsUrl = () => state.wsUrl
